/**
 * Curated real football imagery used as Netflix-style poster fallbacks
 * for courses without a custom cover (V3 directive: no flat placeholders).
 */
const Q = 'auto=format&fit=crop&w=900&q=70';

export const FOOTBALL_COVERS = [
  `https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?${Q}`,
  `https://images.unsplash.com/photo-1552318965-6e6be7484ada?${Q}`,
  `https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?${Q}`,
  `https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9?${Q}`,
  `https://images.unsplash.com/photo-1526232761682-d26e03ac148e?${Q}`,
  `https://images.unsplash.com/photo-1574629810360-7efbbe195018?${Q}`,
  `https://images.unsplash.com/photo-1522778119026-d647f0596c20?${Q}`,
  `https://images.unsplash.com/photo-1560272564-c83b66b1ad12?${Q}`,
];

const hashStr = (s = '') => {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0; // eslint-disable-line no-bitwise
  }
  return h;
};

/** Deterministic cover for a course: custom cover_url or curated real image. */
export const courseCover = (course) =>
  course?.cover_url || FOOTBALL_COVERS[hashStr(course?.course_id || course?.title || 'x') % FOOTBALL_COVERS.length];
